/** Axis and grid styling shared by every chart (frontend-design.md §7): muted ticks, dashed grid, no in-chart title. */
import { CHART } from '@/theme/colors';

export const CHART_AXIS_PROPS = {
  gridAxis: 'x' as const,
  strokeDasharray: '4 4',
  gridColor: CHART.grid,
  textColor: CHART.tick,
  tickLine: 'none' as const,
};
